import { api } from './api'
import { outbox } from './outbox'
import { getDataSnapshot, useTaskStore } from '../store/taskStore'
import { useSyncStore } from '../store/syncStore'

let unsubscribe: (() => void) | null = null
let timer: number | undefined
let applyingRemote = false

export async function bootstrap(userId: string) {
  const sync = useSyncStore.getState()
  sync.setSync({ status: 'loading', error: null })
  try {
    const query = sync.cursor ? `?cursor=${encodeURIComponent(sync.cursor)}` : ''
    const result = await api<{ snapshot: any | null; cursor: string }>(`/api/sync/bootstrap${query}`)
    if (result.snapshot) {
      applyingRemote = true
      useTaskStore.getState().hydrateData(result.snapshot)
      applyingRemote = false
    }
    localStorage.setItem('taskpriority_data_owner', userId)
    sync.setSync({ status: 'synced', cursor: result.cursor, pending: 0 })
    await flush()
  } catch (error) {
    sync.setSync({ status: navigator.onLine ? 'error' : 'offline', error: error instanceof Error ? error.message : 'Falha ao sincronizar.' })
  }
}

export async function flush() {
  if (!navigator.onLine) { useSyncStore.getState().setSync({ status: 'offline' }); return }
  const queued = await outbox.all()
  useSyncStore.getState().setSync({ pending: queued.length, status: queued.length ? 'pending' : 'synced' })
  if (!queued.length) return
  try {
    const result = await api<{ accepted: string[]; cursor: string }>('/api/sync/mutations', { method: 'POST', body: JSON.stringify({ mutations: queued }) })
    await Promise.all(result.accepted.map((id) => outbox.remove(id)))
    useSyncStore.getState().setSync({ pending: 0, status: 'synced', cursor: result.cursor, error: null })
  } catch (error) {
    useSyncStore.getState().setSync({ status: navigator.onLine ? 'error' : 'offline', error: error instanceof Error ? error.message : 'Alterações aguardando sincronização.' })
  }
}

export function startSync() {
  if (unsubscribe) return
  unsubscribe = useTaskStore.subscribe(() => {
    if (applyingRemote) return
    window.clearTimeout(timer)
    timer = window.setTimeout(async () => {
      await outbox.putLatest(getDataSnapshot())
      useSyncStore.getState().setSync({ status: navigator.onLine ? 'pending' : 'offline', pending: 1 })
      await flush()
    }, 700)
  })
  window.addEventListener('online', flush)
  window.addEventListener('offline', () => useSyncStore.getState().setSync({ status: 'offline' }))
}

export function stopSync() {
  unsubscribe?.(); unsubscribe = null
  window.clearTimeout(timer)
  useSyncStore.getState().setSync({ status: 'local', pending: 0, error: null, cursor: null })
}
